import axios from "axios"

function cancelAttendanceFlag({ id }) {
    return axios.post(`/api/v1/attendance-flags/${id}/cancel-attendance-flag`)
}

export const attendanceFlagsService = {
    cancelAttendanceFlag,
}

